<template>
  <main>
    <div class="grid dashboard">
      <chart-generator :chart="chart" v-for="chart in charts" :key="chart"></chart-generator>
    </div>
  </main>
</template>

<script>
  import store from "@/store";
  import ChartGenerator from "../components/ChartGenerator";

  export default {
    data() {
      return {}
    },
    components: {
      ChartGenerator
    },
    mounted() {
      store.dispatch("getDashboardData");
    },
    methods: {
      getColors() {
        const isLight = this.$appState.layoutMode === 'light';
        return {
          teal2Color: isLight ? '#00838F' : '#26c6da',
          spanishOrange2Color: isLight ? '#ef6c00' : '#ffb74d',
          blueFranceColor: isLight ? '#1e88e5' : '#64b5f6',
          stateGrayColor: isLight ? '#607d8b' : '#90a4ae',
          pearColor: isLight ? '#c0ca33' : '#dce775',
          darkCyanColor: isLight ? '#00897b' : '#4db6ac',
          blueColor: isLight ? '#42A5F5' : '#90CAF9',
          orangeColor: isLight ? '#FFA726' : '#FFCC80',
          tealColor: isLight ? '#26A69A' : '#80CBC4',
          limeColor: isLight ? '#D4E157' : '#E6EE9C',
          purpleColor: isLight ? '#AB47BC' : '#CE93D8',
          lightblueColor: isLight ? '#29B6F6' : '#81D4FA',
          deeppurpleColor: isLight ? '#7E57C2' : '#B39DDB',
          indigoColor: isLight ? '#5C6BC0' : '#9FA8DA',
          pinkColor: isLight ? '#EC407A' : '#F48FB1',
          cyanColor: isLight ? '#00ACC1' : '#4DD0E1',
          greenColor: isLight ? '#66BB6A' : '#A5D6A7',
          lightgreenColor: isLight ? '#9CCC65' : '#C5E1A5',
          yellowColor: isLight ? 'FFEE58' : '#FFF59D',
          amberColor: isLight ? '#FFCA28' : '#FFE082',
          deeporangeColor: isLight ? '#FF7043' : '#FFAB91',

          brownColor: isLight ? '#8D6E63' : '#BCAAA4'
        }
      },

      convertPersonnelPotential(personnelPotential){
        const labels = personnelPotential.map(person => this.$t(person.category));
        const establishedUnits = personnelPotential.map(person => person.established_units);
        const physicalUnits = personnelPotential.map(person => person.physical_units);
        return  {
          labels: labels,
          datasets: [
            {
              label: this.$t('established_units'),
              backgroundColor: this.getColors().blueColor,
              data: establishedUnits
            },
            {
              label: this.$t('physical_units'),
              backgroundColor: this.getColors().orangeColor,
              data: physicalUnits
            }
          ]
        };
      },
      convertQualitativeComposition(qualitativeComposition){
        const output = {
          labels: [],
          datasets: []
        };

        qualitativeComposition.forEach(item => {
          output.labels.push(item.year);
        });

        const fields = ['professors', 'doctors_of_sciences', 'candidate_PhDs', 'PhDs', 'docent', 'masters'];
        let i = 0;
        fields.forEach(field => {
          const dataset = {
            label: this.$t(field),
            backgroundColor: this.getColors()[Object.keys(this.getColors())[i]],
            data: []
          };
          qualitativeComposition.forEach(item => {
            dataset.data.push(item[field]);
          });
          output.datasets.push(dataset);
        });
        return output;
      }
    },
    computed: {
      chart_data() {
        return {
          "personnel_potential": [
            {
              "id": 1,
              "created_at": null,
              "updated_at": null,
              "category": "ППС",
              "established_units": 1467.25,
              "physical_units": 1653,
              "deleted_at": null
            },
            {
              "id": 3,
              "created_at": null,
              "updated_at": null,
              "category": "НС",
              "established_units": 37.5,
              "physical_units": 37,
              "deleted_at": null
            },
            {
              "id": 4,
              "created_at": null,
              "updated_at": null,
              "category": "УПП",
              "established_units": 129.25,
              "physical_units": 124,
              "deleted_at": null
            },
            {
              "id": 5,
              "created_at": null,
              "updated_at": null,
              "category": "АУП",
              "established_units": 126,
              "physical_units": 136,
              "deleted_at": null
            },
            {
              "id": 6,
              "created_at": null,
              "updated_at": null,
              "category": "Прочие",
              "established_units": 151,
              "physical_units": 194,
              "deleted_at": null
            }
          ],
          "qualitative_composition": [
            {
              "id": 1,
              "created_at": null,
              "updated_at": null,
              "deleted_at": null,
              "year": "2022",
              "professors": 46,
              "doctors_of_sciences": 98,
              "candidate_PhDs": 223,
              "PhDs": 64,
              "docent": 92,
              "masters": 251
            },
            {
              "id": 2,
              "created_at": null,
              "updated_at": null,
              "deleted_at": null,
              "year": "2021",
              "professors": 42,
              "doctors_of_sciences": 95,
              "candidate_PhDs": 221,
              "PhDs": 60,
              "docent": 100,
              "masters": 200
            }
          ]
        }
      },
      charts() {
        return [
          {"name": "personnel_potential", "type": "bar", "data": this.convertPersonnelPotential(this.chart_data?.personnel_potential)},
          {"name": "qualitative_composition", "type": "bar", "data": this.convertQualitativeComposition(this.chart_data?.qualitative_composition)},
        ]
      },
      loading() {
        return store.state.dashboard.loading
      }
    }
  }
</script>
